import { jsx } from 'react/jsx-runtime';
import { Badge as Badge$1 } from 'baseui/badge';
import { mergeOverrides } from '../../overrides.js';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getVariantStyles = (variant, $theme) => {
  switch (variant) {
    case "primary":
      return {
        backgroundColor: $theme.colors["background-brand-primary"],
        color: $theme.colors["text-global-inverse"]
      };
    case "secondary":
      return {
        backgroundColor: $theme.colors["background-global-secondary"],
        color: $theme.colors["text-global-primary"]
      };
    case "notification":
      return {
        backgroundColor: $theme.colors["background-brand-notification-dot"],
        color: $theme.colors["background-brand-inverse"]
      };
    case "selected":
    default:
      return {
        backgroundColor: $theme.colors["background-brand-alternative"],
        color: $theme.colors["text-global-inverse"]
      };
  }
};
const getSizeStyles = (size) => {
  switch (size) {
    case "dot":
      return {
        height: "8px",
        paddingRight: "0"
      };
    case "small":
      return { height: "16px" };
    case "normal":
    default:
      return { height: "24px" };
  }
};
const getStyles = ({ $theme, variant, size }) => __spreadValues(__spreadValues({}, getVariantStyles(variant, $theme)), getSizeStyles(size));
const Badge = (_a) => {
  var _b = _a, { variant = "selected", size = "normal", content, overrides, $style } = _b, props = __objRest(_b, ["variant", "size", "content", "overrides", "$style"]);
  const resolvedStyle = useResolvedStyle($style);
  return jsx(Badge$1, __spreadValues({ content: size === "dot" ? null : content, shape: "pill", overrides: mergeOverrides({
    Badge: {
      style: (styleProps) => mergeStyles(getStyles(__spreadProps(__spreadValues({}, styleProps), { variant, size })), resolvedStyle)
    }
  }, overrides) }, props));
};

export { Badge };
